<template>
  <div class="profiles-wrapper">
    <transition name="fade" mode="out-in">
      <div class="spinner-wrapper" v-if="fetching">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
    </transition>
    <el-table
      :data="entries"
      stripe
      style="width: 100%"
      class="leaderboard-table"
      :class="{'fetching': fetching}"
      max-height="800"
    ><el-table-column
        type="index"
        min-width="200"
      ></el-table-column>
      <el-table-column
        label="Registro"
        sortable
        min-width="220"
      >
        <template slot-scope="scope">
          {{scope.row.createdAt | localDate}}
        </template>
      </el-table-column>
      <el-table-column
        label="Params"
        sortable
        min-width="220"
      >
        <template slot-scope="scope">
          <vue-json-pretty
            v-if="scope.row.surveyData && scope.row.surveyData.params"
            :data="scope.row.surveyData.params"
          ></vue-json-pretty>
          <vue-json-pretty
            v-if="scope.row.params"
            :data="scope.row.params"
          ></vue-json-pretty>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(column, index2) in columns"
        :key="column.id"
        min-width="220"
      >
        <template slot="header" slot-scope="scope">
          <MultiText
            :column="column"
            :data-set="dataSet"
            :entries="entries"
            :scope="scope"
            :ref="`questionHeader_${column.id}`"
            v-on:open:trigger="openThisQuestion($event)"
          ></MultiText>
        </template>
        <template slot-scope="scope" v-if="scope.row.responses[index2]">
          {{typeof scope.row.responses[index2].selected === 'object' ? scope.row.responses[index2].selected.join(', ') : scope.row.responses[index2].selected | translateNext}}
        </template>
      </el-table-column>
      <el-table-column
        prop="calculatedResponseTime"
        label="Tiempo"
        sortable
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'

export default {
  name: 'AllResponses',

  components: {
    MultiText: () => import('Components/visualization/MultiText'),
    VueJsonPretty
  },

  props: ['entries', 'fetching'],

  data () {
    return {
      columns: []
    }
  },

  computed: {
    dataSet () {
      return this.$store.state.dataSet
    }
  },

  methods: {
    openThisQuestion (event) {
      this.$refs[`questionHeader_${event}`][0].openQuestion(event)
    }
  },

  mounted () {
    // Transform the dataSet so that it can be used by the table
    this.dataSet.forEach((item, index) => {
      this.columns.push({
        id: item.sys.id,
        label: `${index}. ${item.fields.title || item.fields.name}`,
        researchQuestion: item.fields.researchQuestion,
        type: item.sys.contentType.sys.id
      })
    })
  },
  filters: {
    translateNext (value) {
      if (value === 'next') {
        return 'Siguiente'
      }
      return value
    },
    localDate (date) {
      return date
      // TODO: It should in theory display the date using the local format, but es-CO doesn't work well
      var d = new Date(date)
      return d.toLocaleString('es-CO')
    }
  }
}
</script>
<style lang="scss">
.el-drawer__body {
  overflow-y: scroll;
}
</style>

<style scoped lang="scss">
.spinner-wrapper {
  transform: scale(2);
  width: 100%;
  height: 100%;
}
.profiles-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  min-height: calc(100vh - 4em);
  &.fetching {
    opacity: 0.05;
  }
}
.leaderboard-table {
  @include breakpoint($tablet) {
    font-size: 0.6em;
  }
  @include breakpoint($desktop) {
    font-size: 0.4em;
    font-weight: normal;
    line-height: 1;
  }
}

</style>
